import { ClaimRewardTaxFormStatus, ClaimRewardTaxStatus } from '../../../../client/claim-reward/constants';

const BYPASS = 'BYPASS';
const ACCEPTED_STATUSES = [ClaimRewardTaxStatus.Approved, BYPASS];

const TAX_STATUS_RESOLUTIONS = {
  pending: {
    key: 'tax-pending',
    tone: 'info',
    iconClass: 'phoenix-icon-alert',
    titleKey: 'cashout_tax_pending_title',
    textKey: 'cashout_tax_pending_text',
  },
  rejected: {
    key: 'tax-rejected',
    tone: 'critical',
    iconClass: 'phoenix-icon-warning',
    titleKey: 'cashout_tax_rejected_title',
    textKey: 'cashout_tax_rejected_text',
    formButton: {
      labelKey: 'cashout_tax_rejected_action',
    },
  },
  unfinished: {
    key: 'tax-unfinished',
    tone: 'warning',
    iconClass: 'phoenix-icon-warning',
    titleKey: 'cashout_tax_unfinished_title',
    textKey: 'cashout_tax_unfinished_text',
    formButton: {
      labelKey: 'cashout_tax_continue',
    },
  },
  required: {
    key: 'tax-required',
    tone: 'warning',
    iconClass: 'phoenix-icon-alert',
    titleKey: 'cashout_tax_required_title',
    textKey: 'cashout_fill_out_my_tax_form_description',
    formButton: {
      labelKey: 'cashout_tax_get_started',
    },
  },
};

function isTaxRequired(taxAccount) {
  const { provider } = taxAccount || {};

  return !!provider && provider !== 'none';
}

export function isTaxAccountAccepted(taxAccount) {
  if (!isTaxRequired(taxAccount)) {
    return true;
  }

  const {
    status,
  } = taxAccount || {};

  return ACCEPTED_STATUSES.includes(status);
}

export function resolveTaxStatus(taxAccount) {
  if (!taxAccount || isTaxAccountAccepted(taxAccount)) {
    return null;
  }

  const {
    formStatus,
    formUrl,
  } = taxAccount || {};

  if (formStatus === ClaimRewardTaxFormStatus.Started) {
    return {
      ...TAX_STATUS_RESOLUTIONS.unfinished,
      formButton: {
        ...TAX_STATUS_RESOLUTIONS.unfinished.formButton,
        formUrl,
      },
    };
  }

  if (formStatus === ClaimRewardTaxFormStatus.Rejected) {
    return TAX_STATUS_RESOLUTIONS.rejected;
  }

  // eslint-disable-next-line max-len
  if (formStatus === ClaimRewardTaxFormStatus.Submitted) {
    return TAX_STATUS_RESOLUTIONS.pending;
  }

  return TAX_STATUS_RESOLUTIONS.required;
}
